import { useMemo } from 'react';
import { useApplicationContext } from '~/common/context';
import { IUserCustomer } from '~/common/types';
import { TilesHelpers } from '~/connect/helpers';

export function useActiveTiles(customer?: IUserCustomer) {
  const { auth, application } = useApplicationContext();

  return useMemo(
    () =>
      TilesHelpers.resolveVariant(auth.roles, application.features, {
        express: customer?.expressQuoteSearchable ?? false,
      }),
    [customer, auth, application],
  );
}
